var _path, _circle, _path2, _path3, _path4, _circle2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilitiDc70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7754 12.381C23.7754 19.0592 18.3892 25.4557 12.0022 29.7286C5.1603 24.9922 0.224609 19.0629 0.224609 12.381C0.224609 5.66052 5.5032 0.224609 12 0.224609C18.4968 0.224609 23.7754 5.66052 23.7754 12.381Z",
    fill: "#FFC20E",
    stroke: "#008480",
    strokeWidth: 0.449219
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.25,
    r: 8.25,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2214 9.61133L15.5728 15.5846L16.0734 13.0508L18.4384 12.1844L12.2214 9.61133Z",
    fill: "#008480"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7027 12.1846H6L7.88142 13.8978L7.42751 16.4381L12.7027 12.1846Z",
    fill: "#ABE1FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.413 11.3266L13.7643 5.35551L11.3823 6.17609L9.47119 4.5L10.413 11.3266Z",
    fill: "#FFC20E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 23.5,
    r: 2.5,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 22.9828L10.9881 25.375L11.7024 23.3372H10.75C10.9881 22.9237 11.5119 22.0259 11.7024 21.7424C12.1786 21.5298 12.7738 21.6538 13.0119 21.7424L12.1786 22.9828H13.25Z",
    fill: "#FFC30F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilitiDc70);
export default __webpack_public_path__ + "static/media/mobiliti_dc70.6bd89a72c4a43c84c55afa567c39e68f.svg";
export { ForwardRef as ReactComponent };